import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  Stack,
  Divider,
  List,
} from "@mui/material";

import CollectionsTemplate from "../../../components/CollectionsTemplate/index";
import baseTheme from "../../../themes/baseTheme";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material";
import "../Dashboard.css";
import apiinfo from "../../../utils/base-uri.json";
import React, { useState, useImperativeHandle, useRef } from "react";

import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import "../../../Localization/i18n";
import { useTranslation } from "react-i18next";
import Status from "../../../stories/StatusComponent/StatusComponent";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import VendorStatusChange from "../Vendor/VendorStatusChange";
import VendorDetails from "../Vendor/VendorDetails";

export default function NotificationaGriditem({
  status,
  headers = [],
  statusRoleMap,
  ...props
}) {
  status = statusRoleMap[status];
  const { t } = useTranslation();
  const rowPadding = "3px 0";

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const [view, setView] = useState(true);
  const Viewed = () => {
    setView((view) => !view);
  };
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>

      <Box>
        <Box padding={rowPadding}>
          <Stack direction="row" spacing={1}>
            <Tooltip title={props?.vendorName} placement="top" arrow>

              <Typography variant="h6" className="dashboardcontainer_ellipse">
                <a
                  variant="body2"
                  style={{ textDecoration: "none", color: "#2A93DB" }}
                // href={"/vendordetails?pqid=" + props.prequalificationId }
                >
                  {props?.vendorName}
                </a>
              </Typography>

            </Tooltip>
          </Stack>
        </Box>

        <Box padding={rowPadding}>
          <Typography variant="body2">
            {"Purpose"}:&thinsp;{props?.purpose} exp.

          </Typography>
        </Box>
        <Box padding={rowPadding}>
          <Typography variant="body2" >
            {"Email Sent Date"}:&thinsp;
            {GetfVDateFormate(props?.emailSentDate)}
          </Typography>
        </Box>
        <Box padding={rowPadding}>
          <Tooltip title={props?.clientName} placement="top" arrow>
            <Typography variant="body2" className="dashboardcontainer_ellipse">
              {t("Dashboard.client")}:&thinsp;{props?.clientName}
            </Typography>
          </Tooltip>
        </Box>

      </Box>
    </>
  );
}